<template>
  <v-dialog 
    v-model="$store.state.removedialog" 
    width="300">
    <v-card>
      <v-card-title class="title">
        Poista kohde?
      </v-card-title>
      <v-divider/>
      <v-card-text>
        Oletko varma että haluat poistaa kohteen? Menetät kaikki kohteessa olevat varaukset.
      </v-card-text>
      <v-divider/>
      <v-card-actions>
        <v-spacer/>
        <v-btn 
          flat 
          @click="$store.state.removedialog = false">Peruuta</v-btn>
        <v-btn 
          flat 
          color="error" 
          @click="confirm">Poista</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
export default {
	props: ['index']
}
</script>
